import React from 'react';
import cx from 'classnames';
import styles from './index.module.less';

const Layout = ({ children, className }) => (
  <div
    className={cx(styles.boarding, className)}
  >
    {children}
  </div>
);

export default Layout;
